import { DeleteTwoTone, EditTwoTone, LoadingOutlined, PlusOutlined, RollbackOutlined } from "@ant-design/icons";
import { Spin, Row, Button, Col, Input, Table, Tooltip, Select } from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";
import { Link } from "react-router-dom";
import UserService, { roleOption, roleTableShow, userDetailsProps } from "../../Services/UserService";
import { adminContext } from "../../Common/PageRoute";
import AddUser from "./AddUser";
import { PageHeader } from "../../Common/MainLayout";
import { ConfirmationModal } from "../../Common/ConfirmationModal";
import { ApplicationUserStatus, ApplicationUserStatusOptions, IPagingPagingItems } from "../../Common/CommonComponent";
import Checkbox from "antd/es/checkbox/Checkbox";

interface ListDataType {
  key: React.Key;
  id: number;
  fullName: string;
  phoneNumber: string;
  email: string;
  createdBy: any;
  updatedBy: any;
  status: ApplicationUserStatus;
  roles: string[],
  practiceId: number,
}

interface ListData {
  items: ListDataType[];
  totalItems: number;
}
const { Search } = Input;
const AdminUsers = () => {
  const [loading, setLoading] = React.useState(false);
  const [dialog, setDialog] = React.useState<{ type: string; params: any }>({
    type: "",
    params: {},
  });
  const [pagingItems, setPagingItems] = React.useState<IPagingPagingItems>({
    totalRecords: 0,
    currentPage: 1,
    pageSize: 15,
  });
  const [listParams, setListParams] = React.useState<{
    refresh: boolean;
    search: string;
    sortDir: string;
    sortCol: string;
    action: ApplicationUserStatus;
    roles: string;
  }>({
    refresh: true,
    search: "",
    sortDir: "ascend",
    sortCol: "_id",
    action: ApplicationUserStatus.Active,
    roles: ""
  });

  const setListParamsAndRefresh = (key: any, value: any) => {
    setPagingItems({ ...pagingItems, currentPage: 1, pageSize: 15 })
    setListParams((p: any) => ({ ...p, [key]: value }));
  };

  return (
    <>
      <Row style={{ height: 100 }}>
        <Row justify="start" align="middle" style={{ margin: "1px 15px" }}>
          <PageHeader
            item={[
              {
                label: "Admin Users",
              },
            ]}
            style={{ color: "#172B4D" }}
          />
        </Row>
        <Row
          className="p-3"
          style={{
            backgroundColor: "white",
          }}
        >
          <Col span={24}>
            <Row
              gutter={[8, 8]}
              className="pb-3"
              align="middle"
            >
              {/* ================= ADD ================= */}
              <Col xs={12} sm={12} md={6} lg={2} xl={2} xxl={2}>
                <Button
                  type="primary"
                  className="add-btn"
                  block
                  onClick={() => setDialog({ type: "userdailog", params: {} })}
                >
                  <PlusOutlined /> User
                </Button>
              </Col>

              {/* ================= SEARCH ================= */}
              <Col xs={12} sm={12} md={6} lg={{ span: 4, offset: 12 }} xxl={{ span: 3, offset: 15 }}>
                <Search
                  placeholder="Search"
                  onSearch={(val: string) =>
                    setListParamsAndRefresh("search", val)
                  }
                  onChange={(e) =>
                    e.target.value === ""
                      ? setListParamsAndRefresh("search", "")
                      : null
                  }
                  style={{ width: "100%" }}
                />
              </Col>

              {/* ================= Role ================= */}
              <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={2}>
                <Select
                  placeholder="Select Role"
                  defaultValue={""}
                  style={{ width: "100%" }}
                  onChange={(val: string) => setListParamsAndRefresh("roles", val)}
                  options={[{ value: "", label: "All Roles" }, ...roleOption]}
                // options={[
                //   { value: "", label: "All Roles" },
                //   { value: "SUPERADMIN", label: "Super Admin" },
                //   { value: "SUBADMIN", label: "Sub Admin" }
                // ]}
                />
              </Col>

              {/* ================= STATUS ================= */}
              <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={2}>
                <Select
                  placeholder="Select Action"
                  style={{ width: "100%" }}
                  defaultValue={ApplicationUserStatus.Active}
                  onChange={(val: ApplicationUserStatus) => setListParamsAndRefresh("action", val)}
                  options={ApplicationUserStatusOptions?.map((x: any) => ({
                    value: x.value,
                    label: x.label,
                  }))}
                />
              </Col>
            </Row>
          </Col>

          <Col span={24}
          // style={{ minHeight: window.outerHeight - 200 }}
          >
            <Spin
              spinning={loading}
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            >
              <UserDetails
                practiceId={0}
                setLoading={setLoading}
                listParams={listParams}
                setListParams={(v: any) => {
                  setListParams(v);
                }}
                pagingItems={pagingItems}
                setPagingItems={(v: IPagingPagingItems) => {
                  setPagingItems(v);
                }}
              />
            </Spin>
          </Col>
        </Row>
      </Row>

      {dialog.type === "userdailog" && (
        <AddUser
          id={dialog?.params?.id}
          onDismiss={(confirmation: any) => {
            if (confirmation) {
              setListParams({ ...listParams, refresh: !listParams.refresh });
            }
            setDialog({ type: "", params: {} });
          }}
        />
      )}
    </>
  );
};

export default AdminUsers;

export const UserDetails = ({
  practiceId,
  setLoading,
  listParams,
  setListParams,
  pagingItems,
  setPagingItems
}: userDetailsProps) => {
  const { openNotification } = React.useContext(adminContext);
  const [usersList, setUsersList] = React.useState<ListData>({
    items: [],
    totalItems: 0,
  });

  const [trigger, setTrigger] = React.useState(false);
  const [dialog, setDialog] = React.useState<{ type: string; params: any }>({
    type: "",
    params: {},
  });

  const onClickToggleUserStatus = (record: any) => {
    setDialog({
      type: "isActive",
      params: {
        name: record.fullName,
        id: record.id,
        status: record?.status,
      },
    });
  }

  const onTablePageChange = (paging: { current?: number; pageSize?: number }, filter: Record<string, any>, sort: { order?: string; columnKey?: string }) => {
    setListParams && setListParams((prev: any) => {
      return {
        ...prev,
        sortDir: sort?.order,
        sortCol: sort?.columnKey
      }
    })
    if (paging?.current && paging?.pageSize) {
      setPagingItems((prev: any) => {
        return {
          ...prev,
          currentPage: paging?.current,
          pageSize: paging?.pageSize
        }
      });
    }
  }

  const columns: ColumnsType<ListDataType> = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      width: "5%",
      render: (_: any, record: any, index: any) => (
        <p>
          {pagingItems.currentPage > 1
            ? pagingItems.pageSize * (pagingItems.currentPage - 1) + index + 1
            : index + 1}
        </p>
      ),
    },
    {
      title: "Name",
      dataIndex: "fullName",
      key: "FullName",
      sorter: true,
      defaultSortOrder: "ascend",
      width: "18%",
      render: (text: any, record: any) => (
        <Link title={text} to={`/adminuser/profile/${record.id}`} state={{ userName: record.fullName }}>
          {record.fullName}
        </Link>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "Email",
      sorter: true,
      width: "20%",
    },
    {
      title: "Phone number",
      dataIndex: "phoneNumber",
      key: "PhoneNumber",
      sorter: true,
      width: "15%",
    },
    // {
    //   title: "Practice",
    //   dataIndex: "practiceId",
    //   key: " practiceId",
    //   width: "15%",
    //   render: (text) => <label>{`Practice ${text}`}</label>,
    // },

    {
      title: "Roles",
      dataIndex: "roles",
      key: "roles",
      render: (text: any, record: any) => {
        const uniqueRoles: string[] = [...new Set<string>(record?.roles ?? [])];
        return (
          <>
            {uniqueRoles.map((item: any, idx: any) => {
              return (
                <span key={idx}>
                  {roleTableShow[item]}
                  {idx + 1 === record?.roles?.length ? "" : ", "}
                </span>
              );
            })}
          </>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "Id",
      render: (text: any, record: any) => (
        // <div style={{ display: "flex", justifyContent: "space-start" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          {/* // <div style={{ display: "flex", gap: "10px" }}> */}
          <div style={{ width: 24, textAlign: "center" }}>
            {record.status === ApplicationUserStatus.Active &&
              <Tooltip
                title={"Edit"}
                placement="top"
                color="white"
                overlayInnerStyle={{ color: "#000" }}
              >
                <Link to={`/adminuser/profile/${record.id}`} className="edit-btn">
                  <EditTwoTone />
                </Link>
              </Tooltip>
            }
          </div>

          <div style={{ width: 24, textAlign: "center" }}>

            {/* <Tooltip
              title={
                record?.status === ApplicationUserStatus.Active
                  ? "In-Active"
                  : "Active"
              }
              placement="top"
              color="white"
              overlayInnerStyle={{ color: "#000" }}
            >
              {record.status === ApplicationUserStatus.Inactive ? (
                <RollbackOutlined twoToneColor="#52c41a" onClick={(e: any) => onClickToggleUserStatus(record)} />
              ) : (
                <DeleteTwoTone twoToneColor="#ff4d4f" onClick={(e: any) => onClickToggleUserStatus(record)}
                // setSelectChange(record?.isActive ? "In-Active" : "Active");
                />
              )}
            </Tooltip> */}

            <Checkbox
              checked={record.status === ApplicationUserStatus.Active}
              onChange={(e: any) => {
                onClickToggleUserStatus(record)
              }}
            />
          </div>


          {/* <FolderViewOutlined/> */}
        </div>
      ),
    },
  ];

  const getItems = async (start: any, length: any) => {
    let res = await UserService.getUsers(
      start,
      length,
      listParams?.search ?? null,
      listParams?.sortCol ?? null,
      listParams?.sortDir ?? null,
      practiceId,
      listParams?.action ?? ApplicationUserStatus.Active,
      listParams?.roles ?? ""
    );
    if (res?.status) {
      if (setLoading) setLoading(false);
      var data: ListDataType[] = res?.result?.items.map((item: any) => {
        var itemWithKey = {
          key: item?.id,
          id: item?.id,
          fullName: item?.fullName,
          roles: item?.roles,
          phoneNumber: item?.phoneNumber,
          email: item?.email,
          practiceId: item?.practiceId,
          createdBy: item?.createdBy,
          status: item?.status,
        };
        return itemWithKey;
      });
      setUsersList({
        totalItems: res?.result?.totalRecords,
        items: data,
      });
    } else {
      openNotification("error", res.message);
      if (setLoading) setLoading(false);
    }
  };

  React.useEffect(() => {
    if (setLoading) setLoading(true);
    getItems(
      (pagingItems.currentPage - 1) * pagingItems.pageSize,
      pagingItems.pageSize
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listParams, trigger]);

  return (
    <>
      <Row>
        <Col span={24}>
          <Table
            dataSource={usersList?.items}
            columns={columns}
            size="small"
            // className="aoa-custom-table"
            className="border-top-table"
            locale={{
              triggerDesc: "",
              triggerAsc: "",
              cancelSort: "",
            }}
            scroll={{ x: 800, y: window.innerHeight - 256 }}
            pagination={{
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              current: pagingItems.currentPage,
              pageSize: pagingItems.pageSize,
              showSizeChanger: true,
              total: usersList?.totalItems,
              pageSizeOptions: ["1", "15", "25", "50", "100"],
            }}
            onChange={(paging, filter, sort: any) => onTablePageChange(paging, filter, sort)}
          />
        </Col>
      </Row>
      {dialog.type === "isActive" && (
        <ConfirmationModal
          open={true}
          onNo={() => setDialog({ type: "", params: "" })}
          onYes={async () => {
            try {
              const apiData = await UserService.toggleUserStatus(
                dialog.params?.id,
                dialog.params?.status === ApplicationUserStatus.Inactive
                  ? ApplicationUserStatus.Active
                  : ApplicationUserStatus.Inactive
              );
              if (apiData.status) {
                openNotification(
                  "success",
                  `User "${dialog?.params?.name}" ${dialog?.params?.status === ApplicationUserStatus.Inactive
                    ? "Active"
                    : "InActive"
                  } sucessfully.`
                );

                setTrigger((x) => !x);
                setDialog({ type: "", params: "" });
              } else {
                openNotification("error", apiData?.message);
                console.log("error", apiData?.message);
                setDialog({ type: "", params: "" });
              }
            } catch (err) {
              openNotification("error", err);
              console.log("error", err);
              setDialog({ type: "", params: "" });
            } finally {
              setDialog({ type: "", params: "" });
            }
          }}
          text={`Are you sure you want to ${dialog?.params?.status === ApplicationUserStatus.Inactive
            ? "Active"
            : "In-Active"
            }  this "${dialog?.params?.name}" user. ?`}
        />
      )}
    </>
  );
};